export default __webpack_public_path__ + "static/oncf-9367987d4b889caac16ba5e9a668b889.png";